import {array, Mix} from "../../Core/Reflection";
import {TransformBackup} from "../../Core/TransformBackup";
import {Button} from "../Button";
import {Sprite} from "../../Core/Sprite";
import {MusicNotesEmit} from "./MusicNotesEmit";
import * as PIXI from "pixi.js";

export class Bagpipes extends Mix(Button, TransformBackup) {

    readonly items = array(() => this.visuals.addChild(new (Mix(Sprite, TransformBackup))()));
    readonly startItems = array(() => new Sprite());
    readonly notes = array(() => ({x: 0, y: 0, width: 0, height: 0}));
    readonly hitAreaPoints: number[] = [];

    private _inflation = 0;
    private _notes?: MusicNotesEmit[];
    private keyboardSelected = false;

    onLayout() {
        this.clickSfx = undefined;
        for (const item of this.items) {
            item.saveTransform();
        }
        this.inflation = 0;
        this._notes = this.notes.map(it => {
            const notes = this.visuals.addChild(new MusicNotesEmit(it.width, it.height, "#267e3e"));
            notes.x = it.x;
            notes.y = it.y;
            return notes;
        });
        if (this.hitAreaPoints && this.hitAreaPoints.length > 0) {
            this.hitArea = new PIXI.Polygon(this.hitAreaPoints.reduce((a, t, i) => {
                if (i % 2 === 0) {
                    a.push(new PIXI.Point(t));
                } else {
                    a[a.length - 1].y = t;
                }
                return a;
            }, [] as PIXI.Point[]));
        }
    }

    get inflation(): number {
        return this._inflation;
    }

    set inflation(value: number) {
        if (value < 0) value = 0;
        if (value > 1) value = 1;
        this._inflation = value;
        for (let i = 0, n = Math.min(this.items.length, this.startItems.length); i < n; i++) {
            const item = this.items[i];
            const s = this.startItems[i];
            const e = item.getTransformBackup();
            item.scale.set(
                s.scaleX + (e.scaleX - s.scaleX) * value,
                s.scaleY + (e.scaleY - s.scaleY) * value);
            item.position.set(
                s.x + (e.x - s.x) * value,
                s.y + (e.y - s.y) * value);
            item.rotation = s.rotation + (e.rotation - s.rotation) * value;
        }
    }

    emitNotes(value: boolean) {
        this._notes?.forEach(it => it.emitter.emit = value);
    }

    onFocusActivated(): void {
        if (this.enabled && this.worldVisible && !this.getAncestor((it) => !it.interactiveChildren)) {
            this.keyboardSelected = !this.keyboardSelected;
            if (this.keyboardSelected) {
                this.onDown(this);
            } else {
                this.onUp(this);
            }
        }
    }
}